import { PermissionIds } from '@hkm/shared/permissions/enum/Permission';

export function getAppRelevantPermissionIds(): string[] {
  return Object.values(PermissionIds);
}



// WEBPACK FOOTER //
// ./src/shared/permissions/helper/getAppRelevantPermissionIds.ts